import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy tất cả danh mục khách hàng + đối tác theo ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Mảng nhóm: [{ navMenuId, navMenuTitle, navMenuSlug, customers }]
 */
export const getCustomersByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.CUSTOMERS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;
        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }
        return [];
    } catch (error) {
        console.error("Lỗi khi lấy danh sách customers:", error);
        throw error;
    }
};

/**
 * Lấy khách hàng theo ngôn ngữ và menuId (navMenuId)
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @param {number} menuId       - ID của nav menu con (19 = typical, 20 = partners)
 * @returns {Promise<Object|null>} - { navMenuId, navMenuTitle, navMenuSlug, customers }
 */
export const getCustomersByMenuId = async (languageCode, menuId) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.CUSTOMERS.GET_BY_MENU_ID(languageCode, menuId)
        );
        const data = response.data;
        if (data && data.success && Array.isArray(data.data) && data.data.length > 0) {
            return data.data[0];
        }
        return null;
    } catch (error) {
        console.error("Lỗi khi lấy customers theo menuId:", error);
        throw error;
    }
};
